import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  Stack,
} from '@mui/material';
import {
  CardGiftcard as GiftIcon,
  EmojiEvents as TrophyIcon,
  AccountBalanceWallet as WalletIcon,
} from '@mui/icons-material';

function ReferralLanding() {
  const [searchParams] = useSearchParams();
  const [referralData, setReferralData] = useState({
    code: '',
    userId: '',
    nickname: '',
  });

  useEffect(() => {
    const code = searchParams.get('code') || '';
    const userId = searchParams.get('userId') || '';
    const nickname = searchParams.get('nickname') || '';
    setReferralData({ code, userId, nickname });
  }, [searchParams]);

  const handleOpenApp = () => {
    const { code, userId, nickname } = referralData;
    const deepLinkUrl = `cashturtle://invite?code=${code}&userId=${userId}&nickname=${encodeURIComponent(nickname)}`;
    const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.add.claw_reward';
    const appStoreUrl = 'https://apps.apple.com/app/id000000000'; // TODO: 실제 앱스토어 ID

    window.location.href = deepLinkUrl;

    setTimeout(() => {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);
      if (isIOS) {
        window.location.href = appStoreUrl;
      } else if (isAndroid) {
        window.location.href = playStoreUrl;
      } else {
        alert('모바일 기기에서 접속해주세요.');
      }
    }, 2000);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #F5F6F7 0%, #E8F5E9 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        {/* 마스코트 이미지 */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box
            component="img"
            src="/mascot_main.png"
            alt="황금거북이"
            sx={{
              width: 180,
              height: 'auto',
              mx: 'auto',
              filter: 'drop-shadow(0 8px 24px rgba(45,149,0,0.2))',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Box>

        {/* 앱 이름 */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 800,
            color: '#2C2F30',
            textAlign: 'center',
            mb: 1,
          }}
        >
          황금거북이
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: '#595C5D',
            textAlign: 'center',
            mb: 4,
          }}
        >
          등껍질 열고 포인트 받는 리워드 앱
        </Typography>

        {referralData.nickname ? (
          <Box
            sx={{
              bgcolor: '#fff',
              borderRadius: 4,
              p: 4,
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            }}
          >
            {/* 초대 메시지 */}
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, color: '#2C2F30', lineHeight: 1.4 }}
              >
                <span style={{ color: '#2D9500' }}>{referralData.nickname}</span>님이
                <br />
                당신을 초대했어요!
              </Typography>
            </Box>

            {/* 혜택 카드들 */}
            <Stack spacing={2} sx={{ mb: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: '#F0FFF0',
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    bgcolor: 'rgba(45,149,0,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <GiftIcon sx={{ color: '#2D9500' }} />
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ color: '#595C5D', fontSize: 12 }}>
                    초대 보상
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2D9500' }}>
                    첫 출금 시 양쪽 각 500P
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: '#FFF8E1',
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    bgcolor: 'rgba(255,193,7,0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <TrophyIcon sx={{ color: '#F9A825' }} />
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ color: '#595C5D', fontSize: 12 }}>
                    순금 이벤트
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2C2F30' }}>
                    매주 24K 순금 당첨 기회
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  p: 2,
                  bgcolor: '#E3F2FD',
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: '50%',
                    bgcolor: 'rgba(33,150,243,0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <WalletIcon sx={{ color: '#2196F3' }} />
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ color: '#595C5D', fontSize: 12 }}>
                    포인트 출금
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#2C2F30' }}>
                    2,000P부터 현금 출금 가능
                  </Typography>
                </Box>
              </Box>
            </Stack>

            {/* 초대 코드 */}
            <Box
              sx={{
                textAlign: 'center',
                p: 2,
                bgcolor: '#F5F6F7',
                borderRadius: 2,
                mb: 3,
              }}
            >
              <Typography variant="body2" sx={{ color: '#595C5D', mb: 0.5 }}>
                초대 코드
              </Typography>
              <Typography
                variant="h5"
                sx={{ fontWeight: 800, color: '#2D9500', letterSpacing: 3 }}
              >
                {referralData.code}
              </Typography>
            </Box>

            {/* CTA 버튼 */}
            <Button
              fullWidth
              variant="contained"
              size="large"
              onClick={handleOpenApp}
              sx={{
                py: 2,
                fontSize: '1.1rem',
                fontWeight: 700,
                borderRadius: 3,
                bgcolor: '#2D9500',
                color: '#fff',
                boxShadow: '0 4px 12px rgba(45,149,0,0.3)',
                '&:hover': {
                  bgcolor: '#247A00',
                },
              }}
            >
              지금 바로 시작하기
            </Button>

            <Typography
              variant="caption"
              sx={{
                display: 'block',
                textAlign: 'center',
                mt: 2,
                color: '#ADADAD',
                lineHeight: 1.6,
              }}
            >
              버튼을 누르면 앱으로 이동하고,
              <br />
              설치되지 않았다면 스토어로 이동합니다.
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              bgcolor: '#fff',
              borderRadius: 4,
              p: 4,
              textAlign: 'center',
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            }}
          >
            <Typography variant="h6" sx={{ color: '#2C2F30' }} gutterBottom>
              올바른 초대 링크가 아닙니다.
            </Typography>
            <Typography variant="body2" sx={{ color: '#595C5D' }}>
              친구에게 받은 초대 링크를 다시 확인해주세요.
            </Typography>
          </Box>
        )}

        <Typography
          variant="body2"
          sx={{ color: '#ADADAD', textAlign: 'center', mt: 4 }}
        >
          © 2025 황금거북이. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

export default ReferralLanding;
